import { render, staticRenderFns } from "./TrustPilot.vue?vue&type=template&id=0cd974bc"
import script from "./TrustPilot.vue?vue&type=script&lang=js"
export * from "./TrustPilot.vue?vue&type=script&lang=js"
import style0 from "./TrustPilot.vue?vue&type=style&index=0&id=0cd974bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports